import { UserService } from '../../../users/shared/user.service';
import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ProfileNotificationDto } from '../../shared/dto/profile-notification.dto';
import { ProfileNotificationService } from '../../shared/profile-notification.service';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'wl-profile-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.less'],
    standalone: false
})
export class ProfileNotificationsComponent implements OnInit, OnChanges, OnDestroy {
  public notifications: Array<ProfileNotificationDto>;
  private _profileSubscription: Subscription;

  public get newInvoiceUrl() {
    return `/revenue/invoice/new`;
  }

  @Input() profileId: number;
  @Output() relationshipEvent: EventEmitter<any>;
  constructor(
    private _profileNotificationService: ProfileNotificationService,
    private _observationService: ObservationService,
    private _userService: UserService
  ) {
    this.relationshipEvent = new EventEmitter<any>();
  }

  ngOnInit() {
    this.loadData();

    this._profileSubscription = this._observationService.observeProfileRelations().subscribe((id: number) => {
      if (this.profileId === id) {
        this.loadData();
      }
    });
  }
  ngOnChanges() {
    this.loadData();
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private loadData() {
    this._profileNotificationService.getProfileNotifications(this.profileId).then((data: Array<ProfileNotificationDto>) => {
      this._userService.getCurrentUserSecurityElementAccessLevel('Revenue_Module').then((accessLevel: number) => {
        if (accessLevel < 1) {
          const index = data.findIndex((x) => x.NotificationType === 1);
          data.splice(index, 1);
        }
      });
      this._userService.getCurrentUserSecurityElementAccessLevel('ProfileRelated_Profiles_Tab').then((accessLevel: number) => {
        if (accessLevel <= 1) {
          const index = data.findIndex((x) => x.NotificationType === 0);
          data.splice(index, 1);
        }
      });
      this.notifications = data;
    });
  }

  public addRelationship() {
    this.relationshipEvent.emit();
  }
}
